import { twMerge } from '@/styles/tailwindMergeConfig'

interface SkeletonProps {
  isLoading?: boolean
}

export function Skeleton({ isLoading }: SkeletonProps) {
  return (
    <main
      role="progressbar"
      className="flex h-screen w-full flex-col items-center px-7"
    >
      <header
        className={twMerge(
          isLoading && 'animate-pulse',
          'mt-6 flex w-full max-w-screen-xl items-start justify-between pt-3 font-mono'
        )}
      >
        <div className="flex">
          <div>
            <div className="h-6 w-[361px] rounded bg-cromai-m3-sys-light-surface-variant dark:bg-cromai-m3-sys-dark-surface-variant"></div>
            <div className="mt-1 h-4 w-[371px] rounded bg-cromai-m3-sys-light-surface-variant dark:bg-cromai-m3-sys-dark-surface-variant"></div>
            <div className="mt-2 flex gap-4">
              <div className="h-6 w-[224px] rounded bg-cromai-m3-sys-light-surface-variant dark:bg-cromai-m3-sys-dark-surface-variant" />
              <div className="h-6 w-[118px] rounded bg-cromai-m3-sys-light-surface-variant dark:bg-cromai-m3-sys-dark-surface-variant" />
              <div className="h-6 w-[56px] rounded bg-cromai-m3-sys-light-surface-variant dark:bg-cromai-m3-sys-dark-surface-variant" />
            </div>
          </div>
        </div>
        <div className="h-6 w-[361px] rounded bg-cromai-m3-sys-light-surface-variant dark:bg-cromai-m3-sys-dark-surface-variant" />
      </header>

      <section
        className={twMerge(
          isLoading && 'animate-pulse',
          'mt-6 flex h-[calc(100vh-12rem)] w-full max-w-screen-xl flex-col gap-6 lg:flex-row '
        )}
      >
        {/* Aba Links */}
        <div className="flex size-full flex-col items-start gap-2">
          <span className="h-8 w-20 rounded bg-cromai-m3-sys-light-surface-variant dark:bg-cromai-m3-sys-dark-surface-variant" />
          <div
            className={twMerge(
              'bg-cromai-m3-sys-light-surface-variant dark:bg-cromai-m3-sys-dark-surface-variant',
              ' flex h-full w-full rounded'
            )}
          ></div>
        </div>

        {/* Aba Responsaveis */}
        <div className="flex size-full flex-col gap-2 lg:w-[500px]">
          <span className="h-8 w-28 rounded bg-cromai-m3-sys-light-surface-variant dark:bg-cromai-m3-sys-dark-surface-variant" />
          <div className="flex size-full flex-col items-start overflow-auto rounded bg-cromai-m3-sys-light-surface-variant px-6 py-4 font-mono text-labelLarge dark:bg-cromai-m3-sys-dark-surface-variant"></div>
        </div>
      </section>
    </main>
  )
}
